import { baseApi } from "../baseApi";

export const cityApi = baseApi.injectEndpoints({

  endpoints: (builder) => ({

    // CREATE CITY
    createCity: builder.mutation({
      query: (data) => ({
        url: "/city-create",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["City"],
    }),

    // GET CITY
    getCity: builder.query({
      query: ({ page = 1,limit = 10,search = "",status = "",}={}) => 
        `/city-list?page=${page}&limit=${limit}&search=${search}&status=${status}`,
      providesTags: ["City"],
    }),

    // UPDATE CITY
    updateCity: builder.mutation({
      query: (data) => ({
        url: `/city-update`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["City"],
    }),

    changeStatausCity: builder.mutation({
      query: (id) => ({
        url: `/city-status/${id}`,
        method: "GET",
        }),
      invalidatesTags: ["City"],
    }),

 deleteCity: builder.mutation({
  query: (data) => ({
    url: `/city-delete`,
    method: "DELETE",
    body:data
  }),

  invalidatesTags: ["City"],
})

  })

});

export const {

  useCreateCityMutation,
  useGetCityQuery,
  useUpdateCityMutation,
  useDeleteCityMutation,

} = cityApi;